// extracted by mini-css-extract-plugin
export default {"timer":"CartHold_timer__gf+ee","timerExpired":"CartHold_timerExpired__HjKYb","modalTitle":"CartHold_modalTitle__2AeyO","modalText":"CartHold_modalText__lRmUM"};